import { render, staticRenderFns } from "./InterfaceButtons.vue?vue&type=template&id=1badce1a&scoped=true&"
import script from "./InterfaceButtons.vue?vue&type=script&lang=js&"
export * from "./InterfaceButtons.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceButtons.vue?vue&type=style&index=0&id=1badce1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1badce1a",
  null
  
)

export default component.exports